<template>
  <div class="props-gift-item" :class="cssType">
    <div class="icon">
      <!-- <img src="https://static.miniworldroyale.com/payment_miniworldroyale_com/img/icon-gift-coin.ef250905.png" alt="prop-icon"> -->
      <img :src="props.prop.iconUrl" alt="prop-icon">
    </div>
    <div class="name">
      {{ props.prop.name }}{{ $t('accumRecharge.countFuhao') }}{{ props.prop.count }}
    </div>
    <!-- <div class="count">
      
    </div> -->
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  prop: {
    type: Object,
    required: true,
  },
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
